<template>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <div class="container-fluid">
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto mb-2 mb-md-0">
          <li class="nav-item dropdown" v-show="role !== 'leader' && role !== 'employee'">
            <a class="nav-link dropdown-toggle" href="#" id="navbarConfig" role="button" data-bs-toggle="dropdown"
               aria-expanded="false">
              Cadastros
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarConfig">
              <li><a class="dropdown-item" href="/subsidiaries">Estabelecimentos</a></li>
              <li><a class="dropdown-item" href="/holidays">Feriados</a></li>
              <li><a class="dropdown-item" href="/expenses">Despesas</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="/occupations">Funções</a></li>
              <li><a class="dropdown-item" href="/sectors">Setores</a></li>
              <li><a class="dropdown-item" href="/users">Usuários</a></li>
              <li><a class="dropdown-item" href="/teams">Equipes</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="/customers">Clientes</a></li>
              <li><a class="dropdown-item" href="/squads">Clientes por equipes</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="/tasks">Atividades</a></li>
              <li><a class="dropdown-item" href="/task-types">Tipo de trabalho</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarLanc" role="button" data-bs-toggle="dropdown"
               aria-expanded="false">
              Lançamentos
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarLanc">
              <li v-show="role !== 'leader' && role !== 'employee'">
                <a class="dropdown-item" href="/month-expenses">Despesas</a>
              </li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <a class="dropdown-item" href="/employee-costs">Funcionários - custo</a>
              </li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <a class="dropdown-item" href="/customer-fees">Honorários</a>
              </li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" href="/tasks-made">Atividades</a></li>
              <li><a class="dropdown-item" href="/tasks-made-v2">Atividades (V2)</a></li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <a class="dropdown-item" href="/customers-service">Ticket</a>
              </li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <a class="dropdown-item" href="/customers-service-v2">Ticket (V2)</a>
              </li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <hr class="dropdown-divider">
              </li>
              <li v-show="role !== 'leader' && role !== 'employee'">
                <a class="dropdown-item" href="/service-record">Fichas</a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown" v-show="role === 'leader' || role === 'supervisor'">
            <a class="nav-link dropdown-toggle" href="#" id="navbarRel" role="button" data-bs-toggle="dropdown"
               aria-expanded="false">
              Relatórios
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarTel">
              <li><a class="dropdown-item" href="/tasks-made-users-worked">Acompanhamento</a></li>
              <li><a class="dropdown-item" href="/tasks-made-users">Atividades por usuário</a></li>
              <li><a class="dropdown-item" href="/tasks-made-closure">Atividades processadas</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown" v-show="role === 'leader' || role === 'supervisor'">
            <a class="nav-link dropdown-toggle" href="#" id="navbarRel" role="button" data-bs-toggle="dropdown"
               aria-expanded="false">
              Fechamentos
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarTel">
              <li><a class="dropdown-item" href="/employee-resume">Funcionários</a></li>
              <li><a class="dropdown-item" href="/customer-cost-closure">Clientes</a></li>
            </ul>
          </li>
        </ul>
        <ul class="navbar-nav d-flex" style="margin-right: 100px">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarProfile" role="button" data-bs-toggle="dropdown"
               aria-expanded="false">
              {{ userName }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarProfile">
              <li><a class="dropdown-item" v-on:click="password">Alterar Senha</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item" v-on:click="logout">Sair</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'

export default {
  name: "topbar",
  computed: {
    ...mapGetters({
      token: 'auth/token',
      role: 'auth/role',
      userName: 'auth/userName'
    }),
  },
  methods: {
    ...mapActions({
      login_user: 'auth/login',
    }),
    logout() {
      this.login_user({})
      location.reload()
    },
    password() {
      $('#edit-password').modal('show')
    }
  }
};
</script>

<style lang="sass">
.user
  margin-right: 15px
  color: white
</style>
